import PropTypes from 'prop-types';
import React from 'react';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getTranslation } from 'common/react/utils/translations';
import { playerModalSelector } from 'common/store/modules/player-awards/player-modal/selectors';
import { useGetBrownlowPredictorSearchQuery } from 'common/store/modules/api/afl-api';
import { useGetBFAwardsSeasonQuery } from 'common/store/modules/api/cfs-api';

export const PlayerModalVotes = ({ playerName }) => {
    const playerModalData = useSelector(playerModalSelector);
    const isPredictor = playerModalData.isPredictor;
    // eslint-disable-next-line no-magic-numbers
    const seasonYear = playerModalData.seasonPid.substr(4, 4);

    const { data } = useGetBFAwardsSeasonQuery(
        {
            seasonPid: playerModalData.seasonPid
        },
        {
            skip: !playerModalData.seasonPid
        }
    );

    const playerVotesData = useMemo(() => {
        return playerModalData.playerId
            ? data?.players?.find(
                  (item) => item.player.playerId === playerModalData.playerId
              )
            : null;
    }, [playerModalData, data]);

    const { data: predictedData } = useGetBrownlowPredictorSearchQuery(
        {
            compSeasonId: playerModalData.seasonId,
            term: playerName
        },
        {
            skip: !playerModalData.seasonId || !playerName
        }
    );

    const isRoundByRound = playerModalData.modifier === 'round-by-round';

    return (
        <div className="player-awards-player-modal__votes-container">
            {!isPredictor && (
                <div
                    className={`player-awards-player-modal__current-votes ${
                        isRoundByRound
                            ? 'player-awards-player-modal__current-votes--flex-1'
                            : ''
                    }`}
                >
                    <span className="player-awards-player-modal__label player-awards-player-modal__label--full-width">
                        <span>{seasonYear}</span>
                        {' ' + getTranslation('label.votes')}
                    </span>
                    <span className="player-awards-player-modal__votes-count">
                        {playerModalData.playerId
                            ? playerVotesData?.votes ?? '-'
                            : ''}
                    </span>
                </div>
            )}
            {isRoundByRound ? (
                // Round-by-round style: full width like total votes
                !playerModalData?.shouldHidePredicted && (
                    <div
                        className={`player-awards-player-modal__current-votes player-awards-player-modal__current-votes--flex-1`}
                    >
                        <span className="player-awards-player-modal__label player-awards-player-modal__label--full-width">
                            {getTranslation(
                                'label.brownlow.tracker.predictedVotes'
                            )}
                        </span>
                        <span className="player-awards-player-modal__votes-count">
                            {predictedData?.results?.find(
                                (item) =>
                                    item.providerId === playerModalData.playerId
                            )?.totalVotes ?? '-'}
                        </span>
                    </div>
                )
            ) : (
                // Default style: two columns
                <div
                    className={`player-awards-player-modal__other-votes ${
                        playerModalData?.shouldHidePredicted
                            ? 'player-awards-player-modal__other-votes--one-item'
                            : ''
                    }`}
                >
                    <div className="player-awards-player-modal__other-votes-content">
                        <span className="player-awards-player-modal__label">
                            {isPredictor
                                ? getTranslation(
                                      'label.brownlow.tracker.predictedPosition'
                                  )
                                : getTranslation(
                                      'label.brownlow.tracker.position'
                                  )}
                        </span>
                        <span className="player-awards-player-modal__votes-position">
                            {playerModalData.playerId &&
                            playerModalData.player.position
                                ? PULSE.app.common.numberHelper.ordinalSuffix(
                                      playerModalData.player.position
                                  )
                                : '-'}
                        </span>
                    </div>
                    {!playerModalData?.shouldHidePredicted && (
                        <div className="player-awards-player-modal__other-votes-content">
                            <span className="player-awards-player-modal__label">
                                {getTranslation(
                                    'label.brownlow.tracker.predictedVotes'
                                )}
                            </span>
                            <span className="player-awards-player-modal__votes-position">
                                {predictedData?.results?.find(
                                    (item) =>
                                        item.providerId ===
                                        playerModalData.playerId
                                )?.totalVotes ?? '-'}
                            </span>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

PlayerModalVotes.propTypes = {
    playerName: PropTypes.string
};
